module.exports = __webpack_public_path__ + "static/media/previous-paper-analysis.673f2adb.svg";